import { createReducer, RequestStatus } from '@lib/plugin-redux-core';
import { gradingSubmissionHandlers } from './grading-submission.handler';
import { GradingSubmissionState } from './grading-submission.states';

const initialState: Partial<GradingSubmissionState> = {
  error: null,
  attendeeList: [],
  questionReleases: [],
  answers: [],
  submission: null,
  attendeeSubmission: null,
  assignment: null,
  formRelease: null,
  getAttendeeListStatus: RequestStatus.RESET,
  getAttendeeSubmissionStatus: RequestStatus.RESET,
  getAssignmentByIdStatus: RequestStatus.RESET,
  getFormReleaseByIdStatus: RequestStatus.RESET,
  getQuestionReleasesStatus: RequestStatus.RESET,
  getAnswersStatus: RequestStatus.RESET,
  getSubmissionByIdStatus: RequestStatus.RESET,
  updateAnswerStatus: RequestStatus.RESET,
  updateCommentStatus: RequestStatus.RESET,
  updateSubmissionStatus: RequestStatus.RESET,
  updateAttendeeGradedStateStatus: RequestStatus.RESET,
  gradingSubmissionStatus: RequestStatus.RESET,
};

export const gradingSubmissionReducer = createReducer(initialState, [...gradingSubmissionHandlers]);
